import { z } from 'zod';

export const loginSchema = z.object({
  username: z.string().min(1, 'Username is required'),
  password: z.string().min(1, 'Password is required'),
});

export const notificationSchema = z.object({
  targetGroup: z.enum(['all', 'trial', 'active', 'expired']),
  title: z.string().min(1, 'Title is required').max(50, 'Max 50 characters'),
  body: z.string().min(1, 'Body is required').max(150, 'Max 150 characters'),
});

export const appVersionSchema = z.object({
  platform: z.enum(['android', 'ios']),
  version: z.string().min(1, 'Version is required').regex(/^\d+\.\d+\.\d+$/, 'Format: x.x.x'),
  minSupportedVersion: z.string().min(1, 'Required').regex(/^\d+\.\d+\.\d+$/, 'Format: x.x.x'),
  downloadUrl: z.string().url('Must be a valid URL').or(z.string().length(0)),
  releaseNotes: z.string(),
  forceUpdate: z.boolean(),
});

export type LoginFormData = z.infer<typeof loginSchema>;
export type NotificationFormData = z.infer<typeof notificationSchema>;
export type AppVersionFormData = z.infer<typeof appVersionSchema>;
